const secondary = {
    social_bind_with: 'Besitzt du schon ein Konto? Melde dich an, um {{methods, list(type: disjunction;)}} mit deiner Identität zu verbinden.',
};
export default Object.freeze(secondary);
